import { Box } from '@mui/material'
import React from 'react'
import Icons from '../Icons/icons'
import "./AttentionBox.scss"
const AttentionBox = ({ content }) => {
  return (
    <Box className="attention-box-continer">
      {content?.icon && <Box>{content.icon}</Box>}
      <Box>
        {content.title &&<Box className="attention_title"> {content.title}</Box>}
        {content.text &&<Box className="attention_msg" >{content.text}</Box>}
        {content.text_url &&
          content.text_url?.map((data, index) => (
            <Box className="link-text" >
              <a href={data.url} target="_blank">
                <label className="footer-link-text">{data.text} <Icons.link_redirect_arrow/></label>
              </a>
            </Box>
          ))
        }
      </Box>

    </Box>
  )
}

export default AttentionBox